import { useQuery } from '@tanstack/react-query';

import { apiGetInvoicingBilling } from 'api/quote-marketplace';

import type { InvoicingBilling } from 'api/quote-marketplace';

export const useInvoicingBilling = (
  contactRef?: string,
  rfqRef?: string,
  quoteRef?: string,
  isEnabled = true,
) =>
  useQuery<InvoicingBilling, Error>({
    queryKey: ['invoicing-billing', contactRef, rfqRef, quoteRef],
    queryFn: () => apiGetInvoicingBilling(contactRef!, rfqRef!, quoteRef!),
    enabled: isEnabled && Boolean(contactRef && rfqRef && quoteRef),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
